import { Translations } from '../types';

export default {
  home: {
    title: 'WebClip',
    subtitle: 'Secure, instant cross-device clipboard sharing',
    tagline: 'End-to-End Encryption · No Registration · Auto-Expiry',
    createButton: 'Create Secure Clip',
    creating: 'Creating...',
    features: {
      encryption: { title: 'End-to-End Encryption', desc: 'Data is encrypted in your browser before transmission' },
      zeroKnowledge: { title: 'Zero-Knowledge Architecture', desc: 'Server cannot access your content, PIN never leaves browser' },
      realtime: { title: 'Real-Time Sync', desc: 'All connected devices sync instantly, supports text and images' },
    },
    footer: 'Data will be automatically deleted after 24 hours',
  },
  clip: {
    title: 'WebClip',
    loading: 'Loading...',
    notFound: 'Clip Not Found',
    notFoundDesc: 'This clip may have expired or does not exist',
    backToHome: 'Go Home',
    enterPin: 'Enter PIN',
    pinHint: 'Enter the 6-character PIN to access this secure clip',
    lockoutWarning: '3 failed attempts will lock access for 60 seconds',
    connected: 'Connected',
    connecting: 'Connecting...',
    encrypted: 'Encrypted',
    connectedStatus: 'Connected',
  },
  shareBar: {
    copyUrl: 'Copy URL',
    showQR: 'Show QR Code',
    hideQR: 'Hide QR Code',
    pin: 'PIN:',
    showPin: 'Show PIN',
    hidePin: 'Hide PIN',
    copyPin: 'Copy PIN',
    connections: 'connections',
    connected: 'Connected',
  },
  messageList: {
    empty: 'No messages yet',
    emptyHint: 'Share the URL and PIN to start chatting',
    failedToLoad: 'Failed to load image',
    noImageData: 'No image data',
    copy: 'Copy',
    close: 'Close',
    closeEsc: 'Close (Esc)',
    clickToEnlarge: 'Click to enlarge',
    receiving: 'Receiving... {{percent}}%',
    download: 'Download',
  },
  inputBar: {
    placeholder: 'Type a message...',
    connecting: 'Connecting...',
    send: 'Send',
    uploadImage: 'Upload image',
    uploadVideo: 'Upload video',
    fileTooLarge: 'File too large (max 100MB)',
    imageTooLarge: 'Image too large, auto-compressed but still exceeds 1MB limit',
    failedToSend: 'Failed to send',
    uploading: 'Uploading... {{percent}}%',
  },
  language: {
    switch: 'Switch Language',
    zh: '中文',
    en: 'English',
  },
  common: {
    error: 'Error',
    retry: 'Retry',
    copied: 'Copied',
    copy: 'Copy',
  },
  pwa: {
    install: {
      title: 'Install WebClip App',
      description: 'Add to home screen for quick access to secure clipboard',
      iosTitle: 'Add to Home Screen',
      iosDescription: 'Tap the share button, then select "Add to Home Screen"',
      installButton: 'Install',
      laterButton: 'Later',
    },
  },
} satisfies Translations;
